module.exports = __webpack_public_path__ + "img/idea-icon.30e01820.svg";